/**
 * Default: layout > Search
 */

import {
	lockBodyScrolling,
	unlockBodyScrolling
} from '@ifabnpm/bootstrap/utils/scroll.js';

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import Manipulator from '@ifabnpm/bootstrap/dom/manipulator.js';
import EventHandler from '@ifabnpm/bootstrap/dom/event-handler.js';

import Nav from '@ifabnpm/bootstrap/component/nav.js';
import Drawer from '@ifabnpm/bootstrap/component/drawer.js';
import drawer from '@ifabnpm/bootstrap/component/drawer.js';

// -------
// Private
// -------

const NAME      = 'menu';
const DATA_KEY  = `ifab.${NAME}`;
const EVENT_KEY = `.${DATA_KEY}`;
// const API_KEY    = '.data-api';

const pageSearch = SelectorEngine.findOne('#page-search-drawer');

let mainNavInstance;

/**
 * Drawer (Emergencysoverlay)
 */
const setupDrawer = () => {
	const trigger = SelectorEngine.findOne('[aria-controls="page-search-drawer"]');
	const closeBtn = SelectorEngine.findOne('[data-drawer-close]', pageSearch);
	const drawer  = new Drawer(pageSearch, {
		closeButton: false,
		onShow   : function() {
			Manipulator.addClass(trigger, '-active');
		},
		onHidden : () => {
			Manipulator.removeClass(trigger, '-active');
		}
	});

	EventHandler.on(trigger, 'click.ifab.pageSearchDrawer', (event) => {
		event.preventDefault();
		event.stopPropagation();

		if (event.delegateTarget.classList.contains('-active')) {
			drawer.hide();
		} else {
			drawer.show();
		}
	});

	if(closeBtn) {
		EventHandler.on(closeBtn, 'click.ifab.pageSearchDrawer', () => {
			drawer.hide();
		});
	}
};

// -------
// Public
// -------

const search = () => {
	if (pageSearch) {
		setupDrawer();
	}
};

// Export
export default search;
